
/**
 * 플랫폼 지원
 */
export type GetCourseDraftById200SectionsItemLecturesItemPlatformSupport = typeof GetCourseDraftById200SectionsItemLecturesItemPlatformSupport[keyof typeof GetCourseDraftById200SectionsItemLecturesItemPlatformSupport];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCourseDraftById200SectionsItemLecturesItemPlatformSupport = {
  WEB: 'WEB',
  MOBILE: 'MOBILE',
  DESKTOP: 'DESKTOP',
  ALL: 'ALL',
} as const;
